module.exports = __webpack_public_path__ + "static/media/linkedin.340ea99c.svg";